import { render, staticRenderFns } from "./BasketItemSecond.vue?vue&type=template&id=78404253&scoped=true&"
import script from "./BasketItemSecond.vue?vue&type=script&lang=js&"
export * from "./BasketItemSecond.vue?vue&type=script&lang=js&"
import style0 from "./BasketItemSecond.vue?vue&type=style&index=0&id=78404253&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78404253",
  null
  
)

export default component.exports